module.exports = __webpack_public_path__ + "img/facebookIcon.288bdf5c.png";